import axios from "axios";

export default {
  namespaced: true,
  state: {
    holidays: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    holidaysMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = state.isReceiving==true ? true : false;
    },
    RECEIVED_HOLIDAYS(state, payload) {
      state.holidays = payload;
      state.isReceiving = false;
    },
    RECEIVING_HOLIDAYS(state) {
      state.isReceiving = true;
    },
    RECEIVED_HOLIDAY(state, payload) {
      state = Object.assign(state, {
        holidays: [...state.holidays, payload],
        isReceiving: false,
      })
    },
    RECEIVING_HOLIDAY(state) {
      state.isReceiving = true;
    },
    UPDATED_HOLIDAY(state, payload) {
      let index = state.holidays.findIndex(holiday => holiday._id === payload._id);
      state = Object.assign(state, {
        holidays: state.holidays.map((holiday, i) => {
          if (i === index) {
            return Object.assign({}, holiday, payload);
          }
          return holiday;
        }),
        isUpdating: false,
        holidaysMessage: 'Holidays has been updating!',
      })
    },
    UPDATING_HOLIDAY(state) {
      state.isUpdating = true;
    },
    DELETED_HOLIDAY(state, payload) {
      let indexToDelete = state.holidays.findIndex(holiday => holiday._id === payload._id);
      let holidays = [...state.holidays];
      holidays.splice(indexToDelete, 1);
      state = Object.assign(state, {
        holidays: [...holidays],
        isDeleting: false,
        idToDelete: null,
        holidaysMessage: 'Holiday has been Deleted!',
      });
    },
    DELETING_HOLIDAY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteHolidayRequest({dispatch}, payload) {
      dispatch("deletingHoliday", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/holiday/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "DELETE", url: url, headers: headers})
      .then(response => {
        dispatch("deleteHoliday", response.data);
      })
    },
    async getHolidaysRequest({dispatch}) {
      dispatch("receivingHolidays");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/holidays';
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: headers})
      .then(response => {
        dispatch("receiveHolidays", response.data);
      })
    },
    insertHolidayRequest({dispatch}, payload) {
      dispatch("receivingHolidays");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/holiday';
      let data = payload;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "post",url: url,headers: header, data: data})
      .then(response => {
        dispatch("receiveHoliday", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async isDateHoliday({dispatch, state}, date) {
      dispatch("doNothing");
      if(state.holidays.length==0) await dispatch("getHolidaysRequest");
      let holidays = Object.assign([], state.holidays);
      let dates = holidays.map(holiday=>{
        let d = new Date(holiday.holidaydate);
        d.setHours(0,0,0,0);
        return d;
      });

      let d1 = new Date(date);      
      d1.setHours(0,0,0,0);
      let find = dates.find(d=>d.getTime()==d1.getTime());
      let result = find!=null ? true : false;
      return result;
    },
    updateHolidayRequest({dispatch}, payload) {
      dispatch("updatingHoliday");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/holiday/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put",url: url,headers: header,data: payload})
      .then(function (res) {
        dispatch("updateHoliday", res.data);
      })
      .catch(error => {
        this.alertmessage = error.response.data.error;
      });
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveHolidays({commit}, payload) {
      commit("RECEIVED_HOLIDAYS", payload)
    },
    receivingHolidays({commit}) {
      commit("RECEIVING_HOLIDAYS")
    },
    receiveHoliday({commit}, payload) {
      commit("RECEIVED_HOLIDAY", payload)
    },
    receivingHoliday({commit}) {
      commit("RECEIVING_HOLIDAY")
    },
    updateHoliday({commit}, payload) {
      commit("UPDATED_HOLIDAY", payload)
    },
    updatingHoliday({commit}) {
      commit("UPDATING_HOLIDAY")
    },
    deleteHoliday({commit}, payload) {
      commit("DELETED_HOLIDAY", payload)
    },
    deletingHoliday({commit}, payload) {
      commit("DELETING_HOLIDAY", payload)
    }
  },
};
